import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-calendar/dist/Calendar.css';

import '@/public/assets/css/font-awesome-4.7.0.min.css';

import '@/frontend/src/index.css';
import '@/frontend/src/App.css';
import '@/frontend/src/app/admin-views/financials/Animations.css';

import '@/frontend/src/app/admin-views/financials/Animations.css';
import '@/frontend/src/app/common/fields/dateFieldOverride.css';
import '@/frontend/src/app/common/loading/LoadingPage.css';
import '@/frontend/src/app/common/menus/MenuAppBar.css';

import '@/frontend/src/app/admin-views/tasks/TasksCalendar.css';
import { AppProps } from 'next/app';
import Head from 'next/head';

const SCRIPT = `
var version = "${process.env.COMMIT_SHA || 'local'}";
var env = "${process.env.APP_ENV || 'local'}";
`;

export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>AI Insurance</title>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,400i,600,600i,700,700i&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:400,500"
        />
        <script dangerouslySetInnerHTML={{ __html: SCRIPT }} />
        <link
          rel="icon"
          type="image/png"
          href={
            process.env.NODE_ENV === 'development'
              ? '/localdev.png'
              : process.env.APP_ENV === 'stage'
                ? 'staging.png'
                : '/favicon.png'
          }
        />
      </Head>
      <Component {...pageProps} />
    </>
  );
}
